import React from 'react';
import { Totals } from '../../../app/brand/campaign/book/offer/modal/tabs/offer/Totals';
import { TotalTypes } from '../../../enum/TotalTypes';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FiInfo } from 'react-icons/fi';
import { priceSplitter } from '../../../utils/helpers/priceSplitter';
import { useTranslation } from 'react-i18next';

export interface InfluencerFeeTotalsProps {
    hasFee?: boolean;
    isCharity?: boolean;
    feePercentage?: number;
    subTotalAndAddons: number;
    serviceFeeSum: number; // Pass positive value, component will display as negative
    grandTotalSum: number;
    spacingClassName?: string;
    containerClassName?: string;
    isSpendingOffer?: boolean;
    isIvConnectedClub?: boolean;
}

export const InfluencerFeeTotals: React.FC<InfluencerFeeTotalsProps> = React.memo(
    ({
        hasFee = true,
        // isCharity,
        feePercentage = 0,
        subTotalAndAddons,
        serviceFeeSum,
        grandTotalSum,
        spacingClassName = 'w-100',
        containerClassName,
        isSpendingOffer = false,
        isIvConnectedClub = false,
    }) => {
        if (!hasFee) {
            return null;
        }

        const negativeFee = -Math.abs(serviceFeeSum ?? 0);
        const { t } = useTranslation();

        return (
            <div className={containerClassName}>
                {!isSpendingOffer && (
                    <div className={spacingClassName}>
                        <Totals price={subTotalAndAddons} title={TotalTypes.SUBTOTAL_AND_ADDONS} />
                    </div>
                )}
                <div className="py-2">
                    <div className="d-flex align-items-center justify-content-between px-2">
                        <div className="d-flex align-items-center">
                            <p className="mb-0">
                                {t(`brand.campaign.book.offer.modal.${isIvConnectedClub ? 'connected_club' : 'preffered_payout'}`, {
                                    feePercentage: feePercentage ?? '0',
                                })}
                            </p>
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip id="impressions-tooltip">
                                        {t('brand.campaign.book.offer.modal.influencer_fee_tooltip')}
                                    </Tooltip>
                                }
                            >
                                <span className="mb-0">
                                    <FiInfo size={14} className="cursor-pointer ml-1" />
                                </span>
                            </OverlayTrigger>
                        </div>
                        <div className="d-flex">
                            <p className="mb-0 euro-symbol">{priceSplitter(negativeFee)}</p>
                        </div>
                    </div>
                </div>
                <div className={spacingClassName}>
                    <Totals
                        price={grandTotalSum}
                        title={isSpendingOffer ? TotalTypes.GRAND_SPENDING_OFFER : (isIvConnectedClub ? TotalTypes.GRAND_MINUS_CONNECTED_CLUB : TotalTypes.GRAND_MINUS_FEE)}
                        feePercentage={feePercentage}
                    />
                </div>
            </div>
        );
    }
);
